import React from 'react';
import classes from './Footer.module.scss';
import {Row, Col, Container} from "react-bootstrap";
import {Link} from '../link/Link';
import PropTypes from "prop-types";
import {Logo} from "../logo/Logo";

export const Footer = ({minimized, children}) => {
    const copyrightText = '© 2022 Fundever. All right reserved.';

    return (
        <footer className={`${classes['footer']} ${minimized ? classes['minimized'] : ''}`}>
            <div className={classes['footer-container']}>
                {
                    minimized ?
                        <>
                            <div>{copyrightText}</div>
                            <div>
                                {children}
                            </div>
                        </>
                        :
                        <Container fluid className={'p-0 h-100'}>
                            <Row className={'g-0 h-100'}>
                                <Col md={2} className={'d-flex justify-content-start'}>
                                    <Logo />
                                </Col>
                                <Col md={8} className={'d-flex flex-column justify-content-between align-items-center'}>
                                    <div className={classes['main-children']}>
                                        {children}
                                    </div>
                                    <div className={classes['footer-footnote']}>
                                        <span>{copyrightText}</span>
                                        <Link to={'/privacy-policy'} inherit>Privacy Policy</Link>
                                        <Link to={'/terms-of-service'} inherit>Terms of Service</Link>
                                    </div>
                                </Col>
                                <Col md={2} className={'d-flex justify-content-end'}>
                                    <div className={'font-14'}>
                                        <span className={'icon-linkedin me-2'} />
                                        <Link to={'https://www.linkedin.com/company/fundever/'} inherit external>Fundever LinkedIn</Link>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                }
            </div>
        </footer>
    );
};

Footer.propTypes = {
    /**
     * set true for a minimized version of the footer
     */
    minimized: PropTypes.bool,
    /**
     * children of the footer for both minimized and normal types
     */
    children: PropTypes.node
}

Footer.defaultProps = {
    minimized: false,
    children: undefined
}